import { Component, Input } from '@angular/core';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { ProfileResponse } from './profile.response';
import { RbacPermissionsConstant } from '../../../../../../core/services/rbac/rbac-permissions.constant';

@Component({
  selector: 'gtd-widget-conversion-profile',
  templateUrl: './profile.component.html',
})
export class ConversionProfileComponent extends GtdNgWidgetComponentAbstract {
  public data: ProfileResponse = new ProfileResponse();
  @Input() id: number;
  protected readonly key: string = 'Conversion\\Profile';
  RbacPermissionsConstant = RbacPermissionsConstant;
  public isVisibleApproved = false;

  public override afterData(): void {
    this.isVisibleApproved = Object.prototype.hasOwnProperty.call(this.data.conversion || {}, 'is_approved');
  }
}
